import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { CryptoService } from './crypto.service';

const URLS_TO_SKIP = [
  'get-ds-order-details',
  'pdas/get-inter-regional-order-tracking',
  'driver/get-inter-regional-order-by-token',
  'driver/update-inter-regional-order-drop-status-by-token',
];

export const dataDecryptionInterceptor: HttpInterceptorFn = (request, next) => {
  const crypto = inject(CryptoService);

  if (URLS_TO_SKIP.some((skipUrl) => request.url.includes(skipUrl))) {
    return next(request);
  }

  const shouldAddCustomHeader = !request.url.includes('shopify/track-order');
  const modifiedRequest = shouldAddCustomHeader
    ? request.clone({ setHeaders: { 'X-Custom-Header': 'custom-value' } })
    : request;

  return next(modifiedRequest).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body as { obfuscated?: string } | null;
        if (body?.obfuscated) {
          crypto.secretKey = crypto.getKey(body.obfuscated);
          const data = crypto.getData(body.obfuscated);
          return event.clone({
            body: JSON.parse(
              JSON.parse(crypto.decryptData(data, crypto.secretKey)),
            ),
          });
        }
      }
      return event;
    }),
  );
};
